import { render, staticRenderFns } from "./TeacherCalendarComponent.vue?vue&type=template&id=3f3c0a46&"
import script from "./TeacherCalendarComponent.vue?vue&type=script&lang=js&"
export * from "./TeacherCalendarComponent.vue?vue&type=script&lang=js&"
import style0 from "./TeacherCalendarComponent.vue?vue&type=style&index=0&id=3f3c0a46&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports